export enum SolutionName {
  COMPLIANCE = 'compliance',
}
